import { inject, Pipe, PipeTransform } from '@angular/core';
import { RemoteConfigStringKey } from '@marmon/shared/types/config';
import { ConfigService } from '../services';

@Pipe({ name: 'configString' })
export class ConfigStringPipe implements PipeTransform {
	readonly config = inject(ConfigService);

	transform(key: RemoteConfigStringKey) {
		return this.config.getString(key as RemoteConfigStringKey);
	}
}
